import { DetalleServicioPropiedadDto } from "./detalleServicioPropiedadDto.model";

export class CreateDetalleServicioPropiedadRequest {
    
    public detallesServiciosPropiedad:DetalleServicioPropiedadDto[] = []
}